import { Routes } from '@angular/router';
import { AuthGuard } from '../../guard/auth-guard/auth.guard';
import { RoleChildGuard } from '../../guard/auth-guard/role-child.guard';
import { Role } from '../../core/enums/role.enum';

export const afastamentoRoutes: Routes = [
  {
    path: 'afastamento',
    canActivate: [AuthGuard],
    canActivateChild: [RoleChildGuard],
    children: [
      {
        path: 'confirmar-retorno/:id',
        loadComponent: () =>
          import('./analise/analise-afastamento-confirmar-retorno/analise-afastamento-confirmar-retorno.component').then(
            (m) => m.AfastamentoConfirmarRetornoComponent,
          ),
        data: {
          title: 'Confirmar Retorno do Profissional',
          roles: [Role.AFASTAMENTO_GESTOR_CONFIRMAR_RETORNO],
          breadcrumb: [
            { label: 'Gestão de Afastamentos', url: '/afastamento' },
            { label: 'Afastamentos', url: '/afastamento' },
            { label: 'Confirmar Retorno', url: '/afastamento/confirmar-retorno' },
          ],
        },
      },
      {
        path: 'visualizar-analise/:id',
        loadComponent: () =>
          import('./analise/analise-afastamento-visualizar/analise-afastamento-visualizar.component').then(
            (m) => m.AfastamentoAnaliseVisualizarComponent,
          ),
        data: {
          title: 'Visualizar Afastamento',
          roles: [Role.AFASTAMENTO_COORDENADOR_ANALISAR],
          breadcrumb: [
            { label: 'Gestão de Afastamentos', url: '/afastamento' },
            { label: 'Análise de Afastamentos', url: '/afastamento/analise' },
            { label: 'Visualizar Afastamento', url: '/afastamento/visualizar-analise' },
          ],
        },
      },
      {
        path: 'analise-saude-dependente/:id',
        loadComponent: () =>
          import('./analise/analise-afastamento-saude-dependente/analise-afastamento-saude-dependente.component').then(
            (m) => m.AfastamentoAnaliseSaudeDependenteComponent,
          ),
        data: {
          title: 'Analisar Afastamento',
          roles: [Role.AFASTAMENTO_COORDENADOR_ANALISAR],
          breadcrumb: [
            { label: 'Gestão de Afastamentos', url: '/afastamento' },
            { label: 'Análise de Afastamentos', url: '/afastamento/analise' },
            { label: 'Analisar Afastamento', url: '/afastamento/analise' },
          ],
        },
      },
      {
        path: 'editar-analise/:id',
        loadComponent: () =>
          import('./analise/analise-afastamento-saude-dependente/analise-afastamento-saude-dependente.component').then(
            (m) => m.AfastamentoAnaliseSaudeDependenteComponent,
          ),
        data: {
          title: 'Editar Afastamento',
          modoEdicao: true,
          roles: [Role.AFASTAMENTO_COORDENADOR_ANALISAR],
          breadcrumb: [
            { label: 'Gestão de Afastamentos', url: '/afastamento' },
            { label: 'Análise de Afastamentos', url: '/afastamento/analise' },
            { label: 'Editar Afastamento', url: '/afastamento/editar-analise' },
          ],
        },
      },
      {
        path: 'analise',
        loadComponent: () =>
          import('./analise/analise-afastamento.component').then(
            (m) => m.AfastamentoAnaliseComponent,
          ),
        data: {
          title: 'Análise de Afastamentos',
          roles: [Role.AFASTAMENTO_COORDENADOR_ANALISAR, Role.AFASTAMENTO_GESTOR_CONFIRMAR_RETORNO],
          breadcrumb: [
            { label: 'Gestão de Afastamentos', url: '/afastamento' },
            { label: 'Análise de Afastamentos', url: '/afastamento/analise' },
          ],
        },
      },
      {
        path: '',
        loadComponent: () =>
          import('./solicitacao/solicitacao-afastamento.component').then((m) => m.AfastamentoComponent),
        data: {
          title: 'Meus Afastamentos',
          titleByRole: [
            {
              role: Role.AFASTAMENTO_COORDENADOR_CADASTRAR,
              title: 'Afastamentos',
            },
            {
              role: Role.AFASTAMENTO_PROFISSIONAL_CADASTRAR,
              title: 'Meus Afastamentos',
            },
          ],
          roles: [Role.AFASTAMENTO_PROFISSIONAL_CADASTRAR, Role.AFASTAMENTO_COORDENADOR_CADASTRAR, Role.AFASTAMENTO_GESTOR_CONFIRMAR_RETORNO],
          breadcrumb: [{ label: 'Afastamentos', url: '/afastamento' }, { label: 'Meus Afastamentos', url: '/afastamento' }],
          breadcrumbByRole: [
            {
              role: Role.AFASTAMENTO_COORDENADOR_CADASTRAR,
              breadcrumb: [
                { label: 'Gestão de Afastamentos', url: '/afastamento' },
                { label: 'Afastamentos', url: '/afastamento' },
              ],
            },
            {
              role: Role.AFASTAMENTO_PROFISSIONAL_CADASTRAR,
              breadcrumb: [{ label: 'Afastamentos', url: '/afastamento' }, { label: 'Meus Afastamentos', url: '/afastamento' }],
            },
          ],
        },
      },
      {
        path: 'novo/selecionar-tipo',
        loadComponent: () =>
          import('./solicitacao/solicitacao-afastamento-selecionar-tipo/solicitacao-afastamento-selecionar-tipo.component').then(
            (m) => m.AfastamentoSelecionarTipoComponent,
          ),
        data: {
          title: 'Novo Afastamento',
          roles: [Role.AFASTAMENTO_PROFISSIONAL_CADASTRAR, Role.AFASTAMENTO_COORDENADOR_CADASTRAR],
          breadcrumb: [
            { label: 'Meus Afastamentos', url: '/afastamento' },
            { label: 'Novo Afastamento - Selecionar Tipo', url: '/afastamento/novo/selecionar-tipo' },
          ],
          breadcrumbByRole: [
            { role: Role.AFASTAMENTO_COORDENADOR_CADASTRAR, breadcrumb: [
              { label: 'Gestão de Afastamentos', url: '/afastamento' },
              { label: 'Afastamentos', url: '/afastamento' },
              { label: 'Novo Afastamento - Selecionar Tipo', url: '/afastamento/novo/selecionar-tipo' },
            ] },
          ],
        },
      },
      {
        path: 'novo/termo-ciencia',
        loadComponent: () =>
          import('./solicitacao/solicitacao-afastamento-termo-ciencia/solicitacao-afastamento-termo-ciencia.component').then(
            (m) => m.AfastamentoTermoCienciaComponent,
          ),
        data: {
          title: 'Termo de Ciência',
          roles: [Role.AFASTAMENTO_PROFISSIONAL_CADASTRAR, Role.AFASTAMENTO_COORDENADOR_CADASTRAR],
          breadcrumb: [
            { label: 'Meus Afastamentos', url: '/afastamento' },
            { label: 'Novo Afastamento - Selecionar Tipo', url: '/afastamento/novo/selecionar-tipo' },
            { label: 'Termo de Ciência', url: '/afastamento/novo/termo-ciencia' },
          ],
          breadcrumbByRole: [
            { role: Role.AFASTAMENTO_COORDENADOR_CADASTRAR, breadcrumb: [
              { label: 'Gestão de Afastamentos', url: '/afastamento' },
              { label: 'Afastamentos', url: '/afastamento' },
              { label: 'Novo Afastamento - Selecionar Tipo', url: '/afastamento/novo/selecionar-tipo' },
              { label: 'Termo de Ciência', url: '/afastamento/novo/termo-ciencia' },
            ] },
          ],
        },
      },
      {
        path: 'novo',
        loadComponent: () =>
          import('./solicitacao/solicitacao-afastamento-form/solicitacao-afastamento-form.component').then((m) => m.AfastamentoFormComponent),
        data: {
          title: '',
          roles: [Role.AFASTAMENTO_PROFISSIONAL_CADASTRAR, Role.AFASTAMENTO_COORDENADOR_CADASTRAR],
          breadcrumb: [
            { label: 'Meus Afastamentos', url: '/afastamento' },
          ],
          breadcrumbByRole: [
            { role: Role.AFASTAMENTO_COORDENADOR_CADASTRAR, breadcrumb: [
              { label: 'Gestão de Afastamentos', url: '/afastamento' },
              { label: 'Afastamentos', url: '/afastamento' },
            ] },
          ],
        },
      },
      {
        path: 'novo/sucesso/:id',
        loadComponent: () =>
          import('./solicitacao/solicitacao-afastamento-sucesso/solicitacao-afastamento-sucesso.component').then(
            (m) => m.AfastamentoSucessoComponent,
          ),
        data: {
          title: 'Afastamento Concluído',
          roles: [Role.AFASTAMENTO_PROFISSIONAL_CADASTRAR, Role.AFASTAMENTO_COORDENADOR_CADASTRAR],
          breadcrumb: [
            { label: 'Meus Afastamentos', url: '/afastamento' },
            { label: 'Afastamento Concluído', url: '/afastamento/novo/sucesso' },
          ],
          breadcrumbByRole: [
            { role: Role.AFASTAMENTO_COORDENADOR_CADASTRAR, breadcrumb: [
              { label: 'Gestão de Afastamentos', url: '/afastamento' },
              { label: 'Afastamentos', url: '/afastamento' },
              { label: 'Afastamento Concluído', url: '/afastamento/novo/sucesso' },
            ] },
          ],
        },
      },
      {
        path: 'visualizar/:id',
        loadComponent: () =>
          import('./solicitacao/solicitacao-afastamento-visualizar/solicitacao-afastamento-visualizar.component').then(
            (m) => m.AfastamentoVisualizarComponent,
          ),
        data: {
          title: 'Visualizar Afastamento',
          roles: [Role.AFASTAMENTO_VISUALIZAR, Role.AFASTAMENTO_GESTOR_CONFIRMAR_RETORNO],
          breadcrumb: [
            { label: 'Afastamentos', url: '/afastamento' },
            { label: 'Meus Afastamentos', url: '/afastamento' },
            { label: 'Visualizar Afastamento', url: '/afastamento/visualizar' },
          ],
        },
      },
      {
        path: 'editar/:id',
        loadComponent: () =>
          import('./solicitacao/solicitacao-afastamento-form/solicitacao-afastamento-form.component').then((m) => m.AfastamentoFormComponent),
        data: {
          title: 'Editar Afastamento',
          roles: [Role.AFASTAMENTO_EDITAR],
          breadcrumb: [
            { label: 'Afastamentos', url: '/afastamento' },
            { label: 'Meus Afastamentos', url: '/afastamento' },
            { label: 'Editar Afastamento', url: '/afastamento/editar' },
          ],
        },
      },
    ],
  },
];
